import { render, staticRenderFns } from "./PbcTabs.vue?vue&type=template&id=e732d80a&"
import script from "./PbcTabs.vue?vue&type=script&lang=js&"
export * from "./PbcTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports